import * as types from './_actionTypes';

export const fetchNotificationsRequest = () => ({
  type: types.FETCH_NOTIFICATIONS_REQUEST
});

export const fetchNotificationsSuccess = (notifications) => ({
  type: types.FETCH_NOTIFICATIONS_SUCCESS,
  payload: notifications
});

export const fetchNotificationsFailure = (error) => ({
  type: types.FETCH_NOTIFICATIONS_FAILURE,
  payload: error
});

export const sendNotificationRequest = (notificationData) => ({
  type: types.SEND_NOTIFICATION_REQUEST,
  payload: notificationData
});

export const sendNotificationSuccess = (notification) => ({
  type: types.SEND_NOTIFICATION_SUCCESS,
  payload: notification
});

export const sendNotificationFailure = (error) => ({
  type: types.SEND_NOTIFICATION_FAILURE,
  payload: error
});

export const deleteNotificationRequest = (notificationId) => ({
  type: types.DELETE_NOTIFICATION_REQUEST,
  payload: notificationId
});

export const deleteNotificationSuccess = (notificationId) => ({
  type: types.DELETE_NOTIFICATION_SUCCESS,
  payload: notificationId
});

export const deleteNotificationFailure = (error) => ({
  type: types.DELETE_NOTIFICATION_FAILURE,
  payload: error
});

export const fetchCoursesListRequest = (courseId) => ({
  type: types.FETCH_COURSES_LIST_REQUEST,
  payload: courseId
});

export const fetchCoursesListSuccess = (courses) => ({
  type: types.FETCH_COURSES_LIST_SUCCESS,
  payload: courses
});

export const fetchCoursesListFailure = (error) => ({
  type: types.FETCH_COURSES_LIST_FAILURE,
  payload: error
}); 

export const fetchCollegesListRequest = (courseId) => ({
  type: types.FETCH_COLLEGES_LIST_REQUEST,
  payload: courseId
});

export const fetchCollegesListSuccess = (colleges) => ({
  type: types.FETCH_COLLEGES_LIST_SUCCESS,
  payload: colleges
});

export const fetchCollegesListFailure = (error) => ({
  type: types.FETCH_COLLEGES_LIST_FAILURE,
  payload: error
});